import { useCallback } from 'react';

import saveUserHistory, { deriveConversationName } from '@/features/ai-chat/lib/saveHistory';
import type { Conversation, Message } from '@/features/ai-chat/types/chat.types';
import { useSaveUserConfig, useUserConfig } from '@/features/user-config';
import useUserDetails from '@/hooks/useUserDetails';

export function useChatHistorySync(
  conversationId: string | null,
  messagesRef: React.RefObject<Message[]>
) {
  const { data: userConfig, isSuccess: isUserConfigLoaded } = useUserConfig();
  const { userEmail } = useUserDetails();
  const saveUserConfigMutation = useSaveUserConfig(userEmail ?? '');

  return useCallback(() => {
    if (!conversationId || !isUserConfigLoaded || !userConfig) return;
    const messages = messagesRef.current ?? [];
    const timestamp = new Date().toISOString();
    const existing = userConfig.chatHistory as Conversation[];
    const idx = existing.findIndex(c => c.conversationId === conversationId);
    saveUserHistory({
      userConfig,
      saveUser: config => {
        saveUserConfigMutation.mutate(config);
      },
      updatedConversation: {
        conversationId,
        messages,
        timestamp,
        name: deriveConversationName(messages)
      },
      existing,
      idx
    });
  }, [conversationId, saveUserConfigMutation, userConfig, isUserConfigLoaded, messagesRef]);
}
